module.exports = __webpack_public_path__ + "assets/066b6fd4ddffc6f634fbf991ad4b1bcc.mp4";